<template>
  <div class="page">
    <div class="layout">
      <div class="page-title">訂單列表</div>
      <div class="page-box">
        <div class="page-content-box">
          <div class="page-content-row">
            <div >
              <div class="search-text">訂單編號</div>
              <el-input
                v-model="formLabelAlign.orderNoLike"
                placeholder="請輸入訂單編號"
              ></el-input>
            </div>
            <div >
              <div class="search-text">用戶電郵</div>
              <el-input
                v-model="formLabelAlign.email"
                placeholder="請輸入用戶電郵"
              ></el-input>
            </div>
            <div >
              <div class="search-text">訂單日期</div>
              <el-date-picker
                v-model="formLabelAlign.orderDate"
                type="date"
                placeholder="請選擇日期"
                value-format="yyyy-MM-dd"
              >
              </el-date-picker>
            </div>
            <div>
              <div class="search-text">付款類型</div>
              <el-select v-model="formLabelAlign.payType" clearable placeholder="全部">
                <el-option
                  v-for="(item, index) in paymentType.filter(item => item.label !== '升级')"
                  :key="index"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </div>
            <div >
              <div class="search-text">付款狀態</div>
              <el-select v-model="formLabelAlign.status" clearable placeholder="全部">
                <el-option
                  v-for="(item, index) in payStatus"
                  :key="index"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </div>
            <div >
              <el-button size="mini" type="info" class="button-el-el" @click="onSearch"
                >搜尋</el-button
              >
            </div>
          </div>
        </div>
        <el-table
          @sort-change="handleSortChange"
          :data="tableData"
          style="width: 100%"
        >
          <el-table-column label="#" type="index" width="50"> </el-table-column>
          <el-table-column
            prop="orderNo"
            label="訂單編號"
            align="center"
            sortable="custom"
          >
          </el-table-column>
          <el-table-column
            prop="createdAt"
            label="訂單日期"
            width="150"
            align="center"
            sortable="custom"
          >
            <template slot-scope="{ row }">
              <span>{{ row.createdAt | formatDateTime }}</span>
            </template>
          </el-table-column>

          <el-table-column
            prop="userNo"
            label="用戶帳號"
            align="center"
            sortable="custom"
          >
            <template slot-scope="{ row }">
              <span v-if="row.parent">{{ row.parent.userNo }}</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="email"
            label="用戶電郵"
            align="center"
            sortable="custom"
          >
            <template slot-scope="{ row }">
              <span v-if="row.parent">{{ row.parent.email }}</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="payPrice"
            label="訂單金額"
            width="120"
            align="center"
            sortable="custom"
          >
          </el-table-column>
          <el-table-column
            prop="payType"
            label="付款類型"
            width="120"
            align="center"
            sortable="custom"
          >
            <template slot-scope="{ row }">
              <span>{{ row.payType | paymentType  }}</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="status"
            label="支付狀態"
            width="120"
            align="center"
            sortable="custom"
          >
            <template slot-scope="{ row }">
              <span>{{ row.status | payStatus }}</span>
            </template>
          </el-table-column>

          <el-table-column label="操作" width="220" align="center">
            <template slot-scope="{ row }">
              <el-button type="text" v-if="row.payType !== 0"  size="medium" @click="onEditButton(row.id)"
                >編輯</el-button
              >
              <el-button
                type="text"
                size="medium"
                @click="onDetailButton(row.id)"
                >詳情</el-button
              >
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <Pagination
      v-show="total > 0"
      :total="total"
      :page.sync="formLabelAlign._page"
      :limit.sync="formLabelAlign._limit"
      @pagination="getOrders"
    />
  </div>
</template>

<script>
import Pagination from "@/components/Pagination";
import { getOrders } from "@/api/order";
export default {
  components: { Pagination },
  data() {
    return {
      total: 0,
      payStatus: [],
      orderId: null,
      dialogSlotVisible: false,
      centerDialogVisible: false,
      formLabelAlign: {
        orderNoLike: null,
        email: null,
        orderDate: null,
        status: null,
        payType: null,
        _page: 1,
        _limit: 50,
      },
      tableData: [],
    };
  },
  created() {
    this.getOrders();
  },
  methods: {
    handleSortChange(column) {
      if (column.order === "descending") {
        this.formLabelAlign.orderBy = column.prop + " desc";
      } else if (column.order === "ascending") {
        this.formLabelAlign.orderBy = column.prop + " asc";
      } else {
        this.formLabelAlign.orderBy = null;
      }
      this.formLabelAlign._page = 1;
      this.getOrders();
    },
    onReset() {
      Object.keys(this.formLabelAlign).forEach((key) => {
        this.formLabelAlign[key] = null;
        if(key === '_page'){
          this.formLabelAlign[key] = 1
        }
        if(key === '_limit'){
          this.formLabelAlign[key] = 50
        }
      })
      this.getOrders();
    },
    onSearch() {
      this.getOrders();
    },
    onEditButton(id) {
      let path = `/order/${id}/edit`;
      this.resolveRouter(path)
    },
    onDetailButton(id) {
      let path = `/order/${id}`;
      this.resolveRouter(path)
    },
    getOrders() {
      let formLabelAlign = {
        orderNoLike: this.formLabelAlign.orderNoLike,
        email: this.formLabelAlign.email,
        status: this.formLabelAlign.status,
        payType: this.formLabelAlign.payType,
        orderBy: this.formLabelAlign.orderBy,
        startDate:this.formLabelAlign.orderDate,
        endDate:this.formLabelAlign.orderDate,
        _page: this.formLabelAlign._page - 1,
        _limit: this.formLabelAlign._limit,
      };
      getOrders(formLabelAlign).then((v) => {
        this.tableData = v.data;
        this.total = Number(v.headers["x-total-count"]);
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.page {
  .layout {
    .el-row {
      padding: 20px;
      margin-bottom: 20px;

      &:last-child {
        margin-bottom: 0;
      }

      .title {
        font-size: 30px;
      }
    }

    .el-button--text {
      color: #166ea5;
      font-size: 16px;
    }
  }
}
.page-title{
  margin-bottom: 30px;
}
.page-box {
  background-color: #fff;
}
.button-el-el {
  width: 100%;
}
.page-content-box{
  width: 100%;
  max-width: 100%;
  overflow-x: auto;
}
.page-content-row {
    padding: 30px 10px;
    display: grid;
    padding: 20px;
    grid-template-columns: repeat(7, 1fr);
    grid-template-rows: repeat(1, 1fr);
    gap: 8px;
    align-items: end;
}
.page-content-row>div{
  min-width: 170px;
}
.page-content-row>div:nth-child(3){
  min-width: 220px;
}
</style>